
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"{{headerId}}\">{{{escapedHeaderTitle}}}</h1>\n  </header>\n\n  <section>\n    <div class=\"error\"></div>\n\n    <div class=\"graphic graphic-checkbox\">{{#t}}Success{{/t}}</div>\n\n    {{#isSync}}\n      <p class=\"account-ready-service\">{{{escapedReadyToSyncText}}}</p>\n    {{/isSync}}\n\n    {{^isSync}}\n      {{#serviceName}}\n        <p class=\"account-ready-service\">{{#t}}You are now ready to use %(serviceName)s{{/t}}</p>\n      {{/serviceName}}\n      {{^serviceName}}\n          {{#emailVerified}}\n              <p class=\"account-ready-service\">{{{escapedEmailReadyText}}}</p>\n          {{/emailVerified}}\n\n          {{^emailVerified}}\n              <p class=\"account-ready-generic\">{{#t}}Your account is ready!{{/t}}</p>\n          {{/emailVerified}}\n      {{/serviceName}}\n    {{/isSync}}\n\n    <div class=\"marketing-area\"></div>\n  </section>\n</div>\n\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/ready.mustache
// module id = 270
// module chunks = app